/* eslint-disable init-declarations */
/* eslint-disable prefer-const */
/* eslint-disable no-shadow */
export const updateOverlay = (el) => {
  const data = el.getCanvasScope()
  const rootState = el.getRootState()
  if (!data) {
    return
  }

  const { selected, hovered, positions, inContext, Collection } = data

  const isPanning = el.isCanvasMode('panningMode')
  const selectedKey = el.getSelectedKey()
  const hoveredKey = el.getHoveredKey()
  const chosenKey = el.getChosenKey()

  const preventUnchangedLoop = () => {
    if (!positions) return
    if (!el.data.__positions) el.data.__positions = {}
    const __positions = el.data.__positions
    if (
      positions.x === __positions.x &&
      positions.y === __positions.y &&
      positions.scale === __positions.scale &&
      positions.mouseX === __positions.mouseX &&
      positions.mouseY === __positions.mouseY
    ) {
      return
    }
    el.data.__positions = positions
    return true
  }

  const positionsChanged = preventUnchangedLoop()

  return {
    hover: () => {
      if (
        (!positionsChanged && !el.data.previousHovered && !hoveredKey) ||
        (isPanning && isPanning === el.data.previousIsPanning)
      ) {
        return
      }

      el.data.previousHovered = hoveredKey
      el.data.previousIsPanning = isPanning

      el.call('updateLocked', 'hovered')

      if (!hovered || selected === hovered || isPanning) {
        el.Hovered.node.style = 'display: none'
        // el.Hovered.Title.setNodeStyles({
        //   transform: 'translate3d(0, -1em, 1px)',
        //   opacity: '0'
        // })
        return
      }
      // console.warn(hovered.state)
      const { node } = hovered.Flex || hovered
      if (!el.call('isFunction', node?.getBoundingClientRect)) {
        return
      }
      const rect = node?.getBoundingClientRect()

      if (!rect) {
        return
      }
      const { x, y, width, height } = rect

      el.Hovered.setNodeStyles({
        display: 'block',
        transform: `translate3d(${x}px, ${y}px, 1px)`,
        width: `${width}px`,
        height: `${height}px`
      })
      if (
        el.getUserSettings('allowTitleOnArtboard') //&&
        // el.data.previousHovered !== el.getHoveredKey()
      ) {
        // el.Hovered.Title.setNodeStyles({
        //   transform: 'none',
        //   opacity: '1'
        // })
        el.Hovered.Title.update()
      }
      // clearTimeout(hoverTitleTimeout)
      // hoverTitleTimeout = setTimeout(() => {
      // }, 1000) // 2000 milliseconds (2 seconds)
    },
    select: () => {
      // if (!el.data.previousSelected && !el.getSelectedKey()) {
      //   return
      // }
      if (
        (!el.data.previousSelected && !selectedKey) ||
        (isPanning && isPanning === el.data.previousSelectIsPanning)
      ) {
        return
      }

      el.data.previousSelected = selectedKey
      el.data.previousSelectIsPanning = isPanning

      el.call('updateLocked', 'selected')

      if (!selected || el.getRootState('followingUser')) {
        return (el.Selected.node.style = 'display: none')
      }

      if (isPanning) {
        el.Selected.Rect.node.style.opacity = '0'
        el.Selected.ResizeOverlay.node.style.opacity = '0'
        el.Selected.SelectedNavbar.node.style.opacity = '0'
        return
      } else {
        el.Selected.Rect.node.style.opacity = '1'
        el.Selected.ResizeOverlay.node.style.opacity = '1'
        el.Selected.SelectedNavbar.node.style.opacity = '1'
      }

      const { node } = selected.Flex || selected
      if (!el.call('isFunction', node?.getBoundingClientRect)) {
        return
      }
      const rect = node?.getBoundingClientRect()
      if (!rect) {
        return
      }
      const { x, y, width, height } = rect

      if (!el.Selected) {
        return
      }
      el.Selected.setNodeStyles({
        display: 'block',
        transform: `translate3d(${x}px, ${y}px, 1px)`,
        width: `${width}px`,
        height: `${height}px`
      })

      const { activeLayer } = data
      if (el.data.previousActiveLayer !== activeLayer) {
        el.data.previousActiveLayer = activeLayer
        if (activeLayer) {
          el.Selected.Rect.setNodeStyles({ outline: '#2485F0CC 0.5px solid' })
        } else {
          el.Selected.Rect.setNodeStyles({ outline: '#2485F0 2.25px solid' })
        }
      }

      const { SelectedNavbar } = el.Selected
      const title = SelectedNavbar.NavbarButtonSet_title.Text.text
      if (el.getUserSettings('allowTitleOnArtboard') && title !== selectedKey) {
        el.Selected.SelectedNavbar.update()
      }
    },
    hoverLayer: () => {
      const { layerHostComponent } = data

      if (isPanning) {
        el.LayerHovered.node.style = 'display: none'
        return
      }

      let elemToFind = chosenKey
        ? el.getChosenData('chosen')?.demoComponent
        : layerHostComponent && el.findComponentOnCanvas(layerHostComponent)

      const { hoverLayer } = data
      if (!hoverLayer || !elemToFind) {
        const isChanged = hoverLayer !== el.data.previousLayer
        const isSelectedChanged =
          layerHostComponent !== el.data.previousComponent
        if (!isChanged && !isSelectedChanged && el.data.isHoverLayerHidden) {
          return
        }
        el.data.previousLayer = hoverLayer
        el.data.previousComponent = layerHostComponent
        el.data.isHoverLayerHidden = true
        return (el.LayerHovered.node.style = 'display: none')
      }

      if (!chosenKey) {
        if (!el.data.previousComponent && !layerHostComponent) {
          if (el.data.isHoverLayerHidden) {
            return
          }
        }
        el.data.previousComponent = layerHostComponent
      }

      const arrayPath = el.call('joinArrays', ['Flex', 'content'], hoverLayer)
      arrayPath.forEach((item) => {
        const elem = elemToFind[item]
        if (elem) {
          elemToFind = elem
        }
      })

      if (!elemToFind || !elemToFind.node) {
        return
      }

      if (!el.call('isFunction', elemToFind.node?.getBoundingClientRect)) {
        return
      }
      const { x, y, width, height } = elemToFind.node.getBoundingClientRect()
      el.data.isHoverLayerHidden = false

      if (!el.LayerHovered) {
        return
      }

      el.LayerHovered.setNodeStyles({
        display: 'block',
        transform: `translate3d(${x}px, ${y}px, 1px)`,
        width: `${width}px`,
        height: `${height}px`
      })
    },
    selectLayer: () => {
      const { layerHostComponent } = data

      let elemToFind = chosenKey
        ? el.getChosenData('chosen')?.demoComponent
        : layerHostComponent && el.findComponentOnCanvas(layerHostComponent)

      const { activeLayer } = data
      if (!activeLayer || !elemToFind) {
        const isChanged = activeLayer !== el.data.previousLayer
        const isSelectedChanged =
          layerHostComponent !== el.data.previousComponent
        if (!isChanged && !isSelectedChanged && el.data.isSelectedLayerHidden) {
          return
        }
        el.data.previousLayer = activeLayer
        el.data.previousComponent = layerHostComponent
        el.data.isSelectedLayerHidden = true
        return (el.LayerSelected.node.style = 'display: none')
      }

      if (!chosenKey) {
        if (
          !el.data.previousComponent &&
          !layerHostComponent &&
          el.data.isSelectedLayerHidden
        ) {
          return
        }
        el.data.previousComponent = layerHostComponent
      }

      const arrayPath = chosenKey
        ? activeLayer
        : el.call('joinArrays', ['Flex', 'content'], activeLayer)
      arrayPath.forEach((item) => {
        const elem = elemToFind[item]
        if (elem) {
          elemToFind = elem
        }
      })

      if (!elemToFind || !elemToFind.node) {
        return (el.LayerSelected.node.style = 'display: none')
      }
      if (!el.call('isFunction', elemToFind.node?.getBoundingClientRect)) {
        return
      }

      const { x, y, width, height } = elemToFind.node.getBoundingClientRect()
      el.LayerSelected.setNodeStyles({
        display: 'block',
        transform: `translate3d(${x}px, ${y}px, 1px)`,
        width: `${width}px`,
        height: `${height}px`
      })

      el.data.isSelectedLayerHidden = false
    },
    hoverOriginalReference: () => {
      if (data.chosen || !el.getUserSettings('showReferences')) {
        return
      }

      if (
        !el.HoveredExtendComponent ||
        (!el.data.previousComponent && !selectedKey)
      ) {
        return
      }
      el.data.previousComponent = selectedKey

      const { hoverLayer } = data
      const activeComponent = hoverLayer && hoverLayer[hoverLayer?.length - 1]
      const isComponent = el.call('matchesComponentNaming', activeComponent)
      if (!hoverLayer || !selected || !isComponent) {
        return (el.HoveredExtendComponent.node.style = 'display: none')
      }
      const extendedFound = Collection?.lookdown(
        (el) => el.state?.key === activeComponent
      )
      if (
        !extendedFound?.Flex?.node ||
        !el.call('isFunction', extendedFound.Flex.node.getBoundingClientRect)
      ) {
        return
      }
      const { x, y, width, height } =
        extendedFound.Flex.node.getBoundingClientRect()
      el.HoveredExtendComponent.setNodeStyles({
        display: 'block',
        transform: `translate3d(${x}px, ${y}px, 1px)`,
        width: `${width}px`,
        height: `${height}px`
      })
    },
    selectIOriginalReference: () => {
      if (data.chosen || !el.getUserSettings('showReferences')) {
        return
      }

      if (!el.data.previousComponent && !selectedKey) {
        return
      }
      el.data.previousComponent = selectedKey

      const { activeLayer } = data
      const activeComponent =
        activeLayer && activeLayer[activeLayer?.length - 1]
      const isComponent = el.call('matchesComponentNaming', activeComponent)
      if (!activeLayer || !selected || !isComponent) {
        return (el.SelectedExtendComponent.node.style = 'display: none')
      }
      const lookup = selected.lookup('Collection')
      const extendedFound = lookup?.lookdown(
        (el) => el.state?.key === activeComponent
      )
      if (!extendedFound?.Flex?.node) {
        return
      }
      if (!el.call('isFunction', extendedFound.node?.getBoundingClientRect)) {
        return
      }
      const { x, y, width, height } =
        extendedFound.Flex.node.getBoundingClientRect()
      el.SelectedExtendComponent.setNodeStyles({
        display: 'block',
        transform: `translate3d(${x}px, ${y}px, 1px)`,
        width: `${width}px`,
        height: `${height}px`
      })
    },
    drawPeers: () => {
      if (data.chosen || !el.getUserSettings('allowTeamCursors')) {
        return
      }
      const { clients, userId } = rootState
      const currentClients = Object.keys(clients).filter(
        (v) => v !== userId && v.length === userId.length
      )
      const usersCached = currentClients.join('+')

      if (usersCached === el.data.usersCached) {
        return
      }
      el.data.usersCached = usersCached

      if (el.Peers.content) {
        el.Peers.removeContent()
      }
      el.Peers.set({
        tag: 'fragment',
        ...currentClients.map((value) => ({ state: { value } }))
      })
    },
    contextmenu: () => {
      el.variables({
        inContextKey: el.getInContextKey(),
        previousX: positions?.contextX
      }).changed(() => {
        const Canvas = el.getCanvas()
        const { ContextMenu } = Canvas.parent

        if (!ContextMenu?.setNodeStyles) {
          return
        }

        if (!positions?.contextX || !inContext) {
          return ContextMenu.setNodeStyles({
            visibility: 'hidden',
            opacity: '0',
            pointerEvents: 'none',
            display: 'none',
            Dropdown: {
              pointerEvents: 'none'
            },
            SubDropdown: {
              pointerEvents: 'none',
              visibility: 'hidden',
              opacity: '0'
            }
          })
        }

        if (inContext.state) {
          ContextMenu.state.set(el.call('deepClone', inContext.state.parse()))
        } else if (hovered) {
          ContextMenu.state.set(el.call('deepClone', hovered.state?.parse()))
        }

        const { contextX, contextY } = positions
        const { width, height } =
          ContextMenu.Dropdown.node.getBoundingClientRect()
        const { innerWidth, innerHeight } = window
        const diffX =
          contextX + width > innerWidth
            ? Math.abs(innerWidth - contextX - width - 16)
            : 0
        const diffY =
          contextY + height > innerHeight
            ? Math.abs(innerHeight - contextY - height - 16)
            : 0
        ContextMenu.setNodeStyles({
          visibility: 'visible',
          opacity: '1',
          pointerEvents: 'auto',
          display: 'flex',
          transform: `translate3d(${contextX - diffX}px, ${contextY - diffY}px, 1px)`,
          Dropdown: {
            visibility: 'visible',
            opacity: '1',
            pointerEvents: 'auto'
          }
        })
      })
    },
    findAllExtends: () => {
      if (data.chosen || !el.getUserSettings('showReferences')) {
        return
      }

      const { SelectedFindAllExtends } = el

      if (selected?.state?.key?.startsWith('/')) {
        if (SelectedFindAllExtends.content) {
          SelectedFindAllExtends.removeContent()
        }
        return
      }

      let extendedFounds
      if (hovered && selected && hovered !== selected) {
        if (!hovered.state || !selected.state) {
          return
        }
        if (el.data.previousHoveredAllExtends === hovered.state.key) {
          return
        }
        el.data.previousSelectedInAllExtends = null
        el.data.previousHoveredAllExtends = hovered.state.key
        extendedFounds = hovered?.lookdownAll((el) => {
          if (!el.__ref || el.__ref.path.length < 9) {
            return
          }
          return (
            el.call('getChildrenComponentsByKey', selectedKey) &&
            selectedKey !== el.state.key
          )
        })
      } else {
        el.data.previousHoveredAllExtends = null

        if (
          !selected ||
          (!el.data.previousSelectedInAllExtends && !selectedKey)
        ) {
          if (SelectedFindAllExtends.content) {
            SelectedFindAllExtends.removeContent()
          }
          el.data.previousSelectedInAllExtends = null
          return
        }

        if (el.data.previousSelectedInAllExtends === selectedKey) {
          return
        }
        el.data.previousSelectedInAllExtends = selectedKey

        extendedFounds = Collection?.lookdownAll((el) => {
          if (!el.__ref || el.__ref.path.length < 9) {
            return
          }
          return (
            el.call('getChildrenComponentsByKey', selectedKey, el) &&
            el.getSelectedKey() !== el.state.key
          )
        })
      }

      if (!extendedFounds || !extendedFounds.length) {
        if (SelectedFindAllExtends.content) {
          SelectedFindAllExtends.removeContent()
        }
        return
      }

      SelectedFindAllExtends.set({
        tag: 'fragment',

        ...extendedFounds
          .map((ref) => ({
            ref,
            parentRef: ref.lookup((el) => el.state.key && el.Handler) || {}
          }))
          .filter(({ ref, parentRef }) => ref.node && parentRef.node)
          .map(({ ref, parentRef }) => {
            const { x, y, width, height } =
              parentRef.node.getBoundingClientRect()
            return {
              data: { ref, parentRef, parentPos: { x, y, width, height } }
            }
          })
      })
    }
  }
}

export const isActiveNodeSelectable = (document, frameDocument) => {
  const docActivenode = document.activeElement
  const frameActivenode = frameDocument.activeElement

  const docSelection = document.getSelection()
  const frameSelection = frameDocument.getSelection()

  const isTextSelectedInDoc = docSelection && docSelection.toString().length > 0
  const isTextSelectedInFrame =
    frameSelection && frameSelection.toString().length > 0

  return (
    docActivenode.tagName === 'INPUT' ||
    frameActivenode.tagName === 'INPUT' ||
    docActivenode.tagName === 'TEXTAREA' ||
    frameActivenode.tagName === 'TEXTAREA' ||
    docActivenode.tagName === 'SELECT' ||
    frameActivenode.tagName === 'SELECT' ||
    docActivenode.isContentEditable ||
    frameActivenode.isContentEditable ||
    isTextSelectedInDoc ||
    isTextSelectedInFrame
  )
}
